module.exports = __webpack_public_path__ + "img/bg-light-detail.0525d2c1.png";